import { jsx as t, jsxs as y, Fragment as Ce } from "@emotion/react/jsx-runtime";
import { useState as ye, useRef as A, useMemo as f, useEffect as O } from "react";
import { StyledStack as Ie, FullWidthStack as we } from "./SingleSelect.styles.js";
import { useSingleSelectContext as be } from "./SingleSelectContext.js";
import { Icon as ke } from "../../Icon/index.js";
import { Text as _ } from "../../Text/index.js";
import { TextInput as Ve } from "../../TextInput/index.js";
import { getSections as Me, shouldDisplayMenu as xe } from "../helpers.js";
import { TextFieldContainer as Le, DropdownIndicator as Te, SelectInputContainer as ve, MenuListWrapper as Re } from "../Select.styled.js";
import { useKeyboard as Pe } from "./hooks/useKeyboard.js";
import { useSuggestion as De } from "./hooks/useSuggestion.js";
import { getColorNotice as Fe } from "../../TextInput/TextInput.styled.js";
import { MenuList as Ee } from "../../MenuList/MenuList.js";
import { FontAwesomeIconsPartooUsed as l, IconPrefix as Ae } from "../../../types/components/icon.js";
import { SuggestionVisibility as Oe } from "../../../types/components/select.js";
const Qe = () => {
  const {
    dataTrackId: m,
    label: $,
    placeholder: K,
    notice: W,
    icon: j,
    leftElement: B,
    leftElementType: N,
    sections: I,
    createdSections: w,
    disableReset: r,
    required: U,
    disabled: s,
    readOnly: o,
    error: b,
    warning: k,
    success: V,
    emptyMessage: M,
    maxHeight: X,
    loadMore: q,
    isLoading: H,
    hasMore: Y,
    selectedValue: i,
    onChange: g,
    handleSearch: z,
    searchValue: n,
    selectableCardChildren: G,
    creatableProps: x,
    position: L,
    copy: T,
    copyText: J,
    copiedText: Q,
    ignoreSearchFilter: Z,
    showMenu: a,
    setShowMenu: h,
    handleResetSearchField: d,
    addCreatedSection: ee
  } = be(), [v, te] = ye(i), oe = A(null), c = A(null), ne = !o || !T, S = !!i, R = f(() => !r && n, [n, r]), P = f(() => !o && !r && S, [o, S, r]);
  O(() => {
    S || (!a && v && g(v), d());
  }, [a]), O(() => {
    const e = (p) => {
      c.current && !c.current.contains(p.target) && h(!1);
    };
    return window.addEventListener("click", e), () => {
      window.removeEventListener("click", e);
    };
  }, [c]);
  const ie = () => {
    !s && !o && (c?.current?.focus(), te(i), h(!0));
  }, re = (e) => {
    e.stopPropagation(), !s && !o && e.target.dataset.track === `show-filters-${m}` && h((Se) => !Se);
  }, D = f(() => R || P ? l.faCircleXmark : a ? l.faCaretUp : l.faCaretDown, [a, R, P]), se = Fe({
    error: b,
    warning: k,
    success: V
  }), ae = D === l.faCircleXmark ? "secondary" : se, ce = (e, p) => {
    p.stopPropagation(), d(), g(e);
  }, le = (e) => i ? i?.value === e.value : !1, de = (e) => {
    o || (e.stopPropagation(), g(void 0), d());
  }, F = i?.label || n, {
    handleKeyDown: ue
  } = Pe({
    selectedValue: i,
    searchValue: n,
    creatableProps: x
  }), pe = /* @__PURE__ */ t(Le, { ref: c, onClick: ie, disabled: s, children: /* @__PURE__ */ y(Ce, { children: [
    /* @__PURE__ */ t(Ve, { dataTrackId: `${m}__select_input`, ref: oe, value: F, disabled: s, onChange: z, onReset: d, isReset: !1, label: $, placeholder: K, isDropdown: !0, error: b, warning: k, success: V, notice: W, leftElementType: N, leftElement: B, hideInput: !1, required: U, readOnly: o, onKeyDown: ue, copy: T, copyText: J, copiedText: Q }),
    ne && /* @__PURE__ */ t(Ie, { direction: "row", alignItems: "center", gap: "0", children: /* @__PURE__ */ t(Te, { dataTrackId: `show-filters-${m}`, color: ae, disabled: s, icon: j ?? [D, Ae.SOLID], onClick: F && !r ? de : re }) })
  ] }) }), C = f(() => Me({
    sections: [...I, ...w],
    searchValue: n,
    ignoreSearchFilter: Z
  }), [I, w, n]), {
    suggestionProps: u,
    isMenuListVisible: fe
  } = x || {
    isMenuListVisible: !0
  }, me = u?.suggestionVisibility === Oe.ALWAYS_VISIBLE, {
    isSuggestionVisible: E
  } = De({
    searchValue: n.trim(),
    sections: C,
    suggestionProps: u
  }), ge = u ? /* @__PURE__ */ y(we, { direction: "row", alignItems: "center", children: [
    /* @__PURE__ */ t(ke, { icon: [l.faPlus] }),
    /* @__PURE__ */ t(_, { variant: "bodyMMedium", children: u.label }),
    !me && /* @__PURE__ */ t(_, { variant: "bodyMBold", children: ` “${n}“` })
  ] }) : void 0, he = xe(C, a, M, E);
  return /* @__PURE__ */ y(ve, { "data-readonly": o, children: [
    pe,
    he && /* @__PURE__ */ t(Re, { position: L, children: /* @__PURE__ */ t(Ee, { position: L, maxHeight: X, sections: fe ? C : [], itemType: "radio", onChange: ce, isChecked: (e) => !!le(e), loadMore: q, hasMore: Y, isLoading: H, emptyMessage: M, selectableCardChildren: G, isSuggestionVisible: E, suggestionProps: {
      onClick: ee,
      label: ge
    } }) })
  ] });
};
export {
  Qe as SingleSelect
};
